{
  "version": 1,
  "asset_id": "d5d80834-ecd2-47bf-b4c7-3eb387d78a2b",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/d5d80834-ecd2-47bf-b4c7-3eb387d78a2b/sleeve-amateur-3-440.png",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/d5d80834-ecd2-47bf-b4c7-3eb387d78a2b/sleeve-amateur-3-440.png",
  "original_filename": "sleeve-amateur-3-440.png",
  "size": 161362,
  "content_type": "image/png",
  "created_at": "2026-09-29T01:15:44Z"
}
